import { getPremiumPageDiscount, getUIState, isValidDiscount } from "../login/auth_utils";
import { firstWeekDaysLeft } from "./payment_utils";
import { BigPremiumButton } from "./premium-icon-button-ui";

/**
 * This function will be used to show a generic buy premium button 
 * data for showing in UI will be fetched from backend and saved in local storage
 * with one line discount and Buy Premium button which will take you to premium page
 */
function VisitPremiumSection({ discount = getPremiumPageDiscount() }) {
  const uiState = getUIState()
  const daysLeftString = firstWeekDaysLeft()

  const goToPaymentPage = (e) => {
    e.preventDefault();
    window.location.href = '/premium'
  };

  return (
    <div
      className="
        mt-3 flex w-full flex-col items-center justify-center
        rounded-3xl border border-orange-100 bg-gradient-to-br from-orange-50 via-white to-blue-50
        px-4 py-5 text-center shadow-sm
      "
    >
      {isValidDiscount(discount) &&
        <div
          className="
            inline-flex max-w-full flex-wrap items-center justify-center gap-1
            rounded-full border border-orange-200 bg-white
            px-4 py-2 text-sm font-bold text-orange-700 shadow-sm
          "
        >
          <span>{discount.oneLineDescription}</span>
          <span>{discount.discountPercentage}% Discount</span>
        </div>
      }

      {discount && discount.timeLeftString && discount.timeLeftString.length > 0 &&
        <div
          className="
            mt-3 rounded-full bg-green-50 px-4 py-1.5
            text-sm font-semibold text-green-700
          "
        >
          {discount.timeLeftString}
        </div>
      }

      <div className="mt-5">
        <BigPremiumButton
          onClick={goToPaymentPage}
          className="
            px-10 py-3 text-lg
            hover:-translate-y-0.5 hover:bg-orange-600 hover:shadow-orange-200
          "
        />
      </div>
    </div>
  );
}

export {VisitPremiumSection}